// NumberInput.jsx

import React from "react";

const CustomNumberInput2 = ({ onChange, ...props }) => {
  const handleWheel = (e) => {
    e.target.blur();
  };

  const handleKeyDown = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <input
      type="number"
      onWheel={handleWheel}
      onKeyDown={handleKeyDown}
      onChange={onChange}
      {...props}
    />
  );
};

export default CustomNumberInput2;
